import { motion } from "framer-motion";

const disciplines = [
  { n: "01", title: "Diseño web", body: "La base sobre la que gira todo lo demás." },
  { n: "02", title: "Identidad digital", body: "La forma en la que un negocio se presenta antes incluso de hablar." },
  { n: "03", title: "Claridad", body: "Cuidamos cada detalle para que tu mensaje llegue sin ruido." },
  { n: "04", title: "SEO Local", body: "Para que también te encuentren quienes todavía no saben que existes." },
  { n: "05", title: "Ritmo", body: "Webs rápidas, ligeras y listas para lanzar el día que decides publicar." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-16 lg:py-24" style={{ background: "#F2EFEB" }}>
      <div className="max-w-[95%] mx-auto">
        <div className="flex items-start justify-between mb-12 lg:mb-20 gap-8">
          <div>
            <div className="font-sans text-[11px] tracking-[0.24em] uppercase text-[color:var(--ink-60)] mb-5">
              — Disciplinas · Índice 003
            </div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tightest max-w-3xl pb-2">
              Cinco disciplinas.
              <br />
              <span className="font-italic-display">Un objetivo.</span>
            </h2>
            <p className="mt-6 font-sans text-base lg:text-lg leading-relaxed text-[color:var(--ink)]/80 max-w-xl">
              Diseñamos landing pages elegantes, rápidas y listas para lanzar. Cada decisión al servicio del proyecto, no del ruido.
            </p>
          </div>
          <p className="hidden lg:block max-w-[13rem] text-right font-sans text-[13px] leading-relaxed text-[color:var(--ink-60)]">
            Webs bonitas. Sin complicaciones. Sin agencias gigantes.
          </p>
        </div>

        {/* Five editorial columns — not cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-8 gap-y-10 border-t border-[color:var(--ink-10)] pt-10">
          {disciplines.map((d, i) => (
            <motion.div
              key={d.n}
              data-testid={`service-col-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: i * 0.08 }}
              className="lg:border-l lg:border-[color:var(--ink-10)] lg:pl-5 first:lg:border-l-0 first:lg:pl-0"
            >
              <div className="font-sans text-[12px] tracking-[0.22em] uppercase text-[color:var(--ink-60)] mb-6">
                {d.n}
              </div>
              <h3 className="font-display text-2xl lg:text-[1.7rem] leading-[1.1] tighter pb-1 mb-4">
                {i % 2 === 1 ? <span className="font-italic-display">{d.title}</span> : d.title}
              </h3>
              <p className="font-sans text-sm leading-relaxed text-[color:var(--ink)]/75">
                {d.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
